import PropTypes from 'prop-types';
import React from 'react';

import uniqueId from '@tinkoff/utils/uniqueId';

import {Client4} from 'mattermost-redux/client';

import * as Utils from 'utils/utils';
import ProfilePicture from 'components/profile_picture';
import UserProfile from 'components/user_profile';

import FormattedMarkdownMessage from 'components/formatted_markdown_message';
import Nbsp from 'components/html_entities/nbsp';
import CustomStatusEmoji from 'components/custom_status/custom_status_emoji';

const EMOJI_STYLE = {
    marginLeft: 0,
    marginBottom: -3,
};

const SPAN_STYLE = {
    paddingLeft: 4,
};

export default class UserListRow extends React.PureComponent {
    static get propTypes() {
        return {
            user: PropTypes.object.isRequired,
            status: PropTypes.string,
            extraInfo: PropTypes.arrayOf(PropTypes.object),
            actions: PropTypes.arrayOf(PropTypes.func),
            actionProps: PropTypes.object,
            actionUserProps: PropTypes.object,
            index: PropTypes.number,
            totalUsers: PropTypes.number,
            userCount: PropTypes.number,
            onProfilePopoverOpen: PropTypes.func,
        };
    }

    static defaultProps = {
        extraInfo: [],
        actions: [],
        actionProps: {},
        actionUserProps: {},
    };

    containerId = 'user_list_row_' + uniqueId();

    onProfilePopoverOpen = () => {
        this.props.onProfilePopoverOpen?.();
    }

    render() {
        let buttons = null;
        if (this.props.actions) {
            buttons = this.props.actions.map((Action, index) => {
                return (
                    <Action
                        key={index.toString()}
                        user={this.props.user}
                        index={this.props.index}
                        totalUsers={this.props.totalUsers}
                        {...this.props.actionProps}
                        {...this.props.actionUserProps}
                    />
                );
            });
        }

        // QUICK HACK, NEEDS A PROP FOR TOGGLING STATUS
        let email = this.props.user.email;
        let emailStyle = 'more-modal__description';
        let status;
        if (this.props.extraInfo && this.props.extraInfo.length > 0) {
            email = (
                <FormattedMarkdownMessage
                    id='admin.user_item.emailTitle'
                    defaultMessage='**Email:** {email}'
                    values={{
                        email: this.props.user.email,
                    }}
                />
            );
            emailStyle = '';
        } else if (this.props.user.status) {
            status = this.props.user.status;
        } else {
            status = this.props.status;
        }

        if (this.props.user.is_bot) {
            status = null;
            email = null;
        }

        let userCountID = null;
        let userCountEmail = null;
        if (this.props.userCount >= 0) {
            userCountID = Utils.createSafeId('userListRowName' + this.props.userCount);
            userCountEmail = Utils.createSafeId('userListRowEmail' + this.props.userCount);
        }

        return (
            <div
                id={this.containerId}
                key={this.props.user.id}
                className='more-modal__row'
            >
                <ProfilePicture
                    appendId={this.containerId}
                    src={Client4.getProfilePictureUrl(this.props.user.id, this.props.user.last_picture_update)}
                    status={status}
                    size={36}
                    userId={this.props.user.id}
                    showProfilePopover={true}
                    hasMention={true}
                    username={this.props.user.username}
                    onProfilePopoverOpen={this.onProfilePopoverOpen}
                />
                <div
                    className='more-modal__details'
                    data-testid='userListItemDetails'
                >
                    <div className='d-flex whitespace--nowrap'>
                        <div
                            id={userCountID}
                            className='more-modal__name'
                        >
                            <UserProfile
                                appendId={this.containerId}
                                userId={this.props.user.id}
                                hasMention={true}
                                displayUsername={true}
                                onProfilePopoverOpen={this.onProfilePopoverOpen}
                            />
                            <Nbsp/>
                            {
                                this.props.user.first_name || this.props.user.last_name || this.props.user.nickname ? '-' : null
                            }
                            <Nbsp/>
                            {Utils.displayFullAndNicknameForUser(this.props.user)}
                        </div>
                        <CustomStatusEmoji
                            userID={this.props.user.id}
                            emojiSize={15}
                            showTooltip={true}
                            emojiStyle={EMOJI_STYLE}
                            spanStyle={SPAN_STYLE}
                        />
                    </div>
                    <div
                        id={userCountEmail}
                        className={emailStyle}
                    >
                        {email}
                    </div>
                    {this.props.extraInfo}
                </div>
                <div
                    data-testid='userListItemActions'
                    className='more-modal__actions'
                >
                    {buttons}
                </div>
            </div>
        );
    }
}
